import { NgModule } from '@angular/core';
import { RouterModule, Routes, RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './app-routing-cache.strategy';
import { ModalsRoutingModule } from './modals/modals-routing.module';
import { ModalsModule } from './modals/modals.module';
import { MainRoutingModule } from './pages/main/main-routing.module';
import { MainModule } from './pages/main/main.module';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule) },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // onSameUrlNavigation:'reload',
      scrollPositionRestoration: 'enabled',
    }),
    ModalsModule,
    ModalsRoutingModule,
    MainModule,
    MainRoutingModule,
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: CacheRouteReuseStrategy,
    },
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
